import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import type { IMapTooltip } from "../../models/storeModels/IMapTooltip";


const initialState: IMapTooltip = {
    mapTooltipIsEnabled: false,
    mapTooltipIsVisible: false,
    mapTooltipIsLoading: false,
    tooltipRoadName: 'Дорога отсутствует',
    tooltipPathName: 'Направление не определено',
    tooltipKm: 'Не удалось определить',
    tooltipNormativityMarker: false,
    tooltipSegmentEnding: null,
    tooltipSegmentStart: null,
    tooltipInfoCopied: false,
    length: null,
    executorOrgName: null,
    eventYear: null,
    roadBedType: null,
    roadBedTypeId: null,
    roadCategory: null,
    roadCategoryId: null,
    roadAccidentDate: null,
    roadAccidentTime: null,
    roadAccidentType: null,
    roadAccidentTypeId: null,
    roadAccidentDeathRoll: null,
    roadAccidentWoundedCount: null,
    roadAccidentSegmentTotalAccidentNumber: null,
    roadAccidentSegmentStatus: null,
    workState: null,
    eventTypeString: null,
    eventTypeId: null
}

export const mapTooltipSlice = createSlice({
    name: 'mapTooltip',
    initialState,
    reducers: {
        // состояние включенности подсказки (вкл./выкл. по кнопке)
        setMapTooltipIsEnabled(state, action: PayloadAction<any>) {
            state.mapTooltipIsEnabled = action.payload
        },
        // состояние включенности подсказки (вкл./выкл. по кнопке)
        setMapTooltipIsLoading(state, action: PayloadAction<any>) {
            state.mapTooltipIsLoading = action.payload
        },
        // состояние видимости подсказки (если нет объектов, то не видим)
        setMapTooltipIsVisible(state, action: PayloadAction<any>) {
            state.mapTooltipIsVisible = action.payload
        },
        // общие поля
        setMapTooltipRoadName(state, action: PayloadAction<string>) {
            state.tooltipRoadName = action.payload
        },
        setMapTooltipPathName(state, action: PayloadAction<string>) {
            state.tooltipPathName = action.payload
        },
        setMapTooltipKm(state, action: PayloadAction<string>) {
            state.tooltipKm = action.payload
        },
        setMapTooltipSegmentStart(state, action: PayloadAction<any>) {
            state.tooltipSegmentStart = action.payload
        },
        setMapTooltipSegmentEnding(state, action: PayloadAction<any>) {
            state.tooltipSegmentEnding = action.payload
        },
        setMapTooltipInfoCopied(state, action: PayloadAction<boolean>) {
            state.tooltipInfoCopied = action.payload
        },
        setMapTooltipLength(state, action: PayloadAction<any>) {
            state.length = action.payload
        },
        // поле для участка нормативности
        setMapTooltipNormativityMarker(state, action: PayloadAction<any>) {
            state.tooltipNormativityMarker = action.payload
        },
        // поля для участка диагностики
        setMapTooltipExecutorOrgName(state, action: PayloadAction<any>) {
            state.executorOrgName = action.payload
        },
        setMapTooltipEventYear(state, action: PayloadAction<any>) {
            state.eventYear = action.payload
        },
        // поля для типа дорожной одежды
        setMapTooltipRoadBedType(state, action: PayloadAction<any>) {
            state.roadBedType = action.payload.roadBedType
            state.roadBedTypeId = action.payload.roadBedTypeId
        },
        // поля для категорийного участка
        setMapTooltipRoadCategory(state, action: PayloadAction<any>) {
            state.roadCategory = action.payload.roadCategory
            state.roadCategoryId = action.payload.roadCategoryId
        },
        // поля для ДТП
        setMapTooltipRoadAccidentInfo(state, action: PayloadAction<any>) {
            state.roadAccidentDate = action.payload.roadAccidentDate
            state.roadAccidentTime = action.payload.roadAccidentTime
            state.roadAccidentType = action.payload.roadAccidentType
            state.roadAccidentTypeId = action.payload.roadAccidentTypeId
            state.roadAccidentDeathRoll = action.payload.roadAccidentDeathRoll
            state.roadAccidentWoundedCount = action.payload.roadAccidentWoundedCount
        },
        // поля для участка концентрации ДТП
        setMapTooltipRoadAccidentSegmentInfo(state, action: PayloadAction<any>) {
            state.roadAccidentSegmentTotalAccidentNumber = action.payload.roadAccidentSegmentTotalAccidentNumber
            state.roadAccidentSegmentStatus = action.payload.roadAccidentSegmentStatus
        },
        // поля для запланированных и проведенных работ
        setMapTooltipWorkState(state, action: PayloadAction<any>) {
            state.workState = action.payload
        },
        setMapTooltipEventTypeString(state, action: PayloadAction<any>) {
            state.eventTypeString = action.payload
        },
        setMapTooltipEventTypeId(state, action: PayloadAction<any>) {
            state.eventTypeId = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const {
    setMapTooltipIsEnabled,
    setMapTooltipInfoCopied,
    setMapTooltipIsLoading,
    setMapTooltipKm,
    setMapTooltipNormativityMarker,
    setMapTooltipPathName,
    setMapTooltipRoadName,
    setMapTooltipSegmentEnding,
    setMapTooltipSegmentStart,
    setMapTooltipIsVisible,
    setMapTooltipExecutorOrgName,
    setMapTooltipLength,
    setMapTooltipEventYear,
    setMapTooltipRoadBedType,
    setMapTooltipRoadCategory,
    setMapTooltipRoadAccidentInfo,
    setMapTooltipRoadAccidentSegmentInfo,
    setMapTooltipWorkState,
    setMapTooltipEventTypeString,
    setMapTooltipEventTypeId
} = mapTooltipSlice.actions
export const mapTooltipReducer = mapTooltipSlice.reducer;
